import {
  GET_USER_PERMISSIONS_AND_ROLES_START,
  GET_USER_PERMISSIONS_AND_ROLES_SUCCESS,
  GET_USER_PERMISSIONS_AND_ROLES_FAIL,
  SET_USER_PERMISSIONS_START,
  SET_USER_PERMISSIONS_SUCCESS,
  SET_USER_PERMISSIONS_FAIL,
  GET_USER_PERMISSIONS_START,
  GET_USER_PERMISSIONS_SUCCESS,
  GET_USER_PERMISSIONS_FAIL,
  GET_CURRENT_USERS_PERMISSIONS_START,
  GET_CURRENT_USERS_PERMISSIONS_FAIL,
  GET_CURRENT_USERS_PERMISSIONS_SUCCESS
} from './constants';

export const userPermissionsReducer = (
  state = {
    userPermissionsAndRoles: { permissions: {}, roles: []},
    userPermissions: [],  // [{id, name, slug}...]
    currentUsersPermissions: {},
    fetchingList: false,
    fetchingItem: false,
    error: {}
  },
    action
) => {
  switch (action.type) {
    case GET_USER_PERMISSIONS_AND_ROLES_START:
    case GET_USER_PERMISSIONS_START:
    case GET_CURRENT_USERS_PERMISSIONS_START:
      return { ...state, fetchingList: true };

    case GET_USER_PERMISSIONS_AND_ROLES_SUCCESS:
      return {
        ...state,
        fetchingList: false,
        userPermissionsAndRoles: action.payload
      };
    case GET_USER_PERMISSIONS_SUCCESS:
      return {
        ...state,
        fetchingList: false,
        userPermissions: action.payload
      };

    case GET_CURRENT_USERS_PERMISSIONS_SUCCESS:
      return {
        ...state,
        fetchingList: false,
        currentUsersPermissions: action.payload
      };

    case GET_USER_PERMISSIONS_AND_ROLES_FAIL:
    case GET_USER_PERMISSIONS_FAIL:
    case GET_CURRENT_USERS_PERMISSIONS_FAIL:
      return { ...state, fetchingList: false, error: action.payload };

    case SET_USER_PERMISSIONS_START:
      return { ...state, fetchingItem: true };
    case SET_USER_PERMISSIONS_SUCCESS:
      return {
        ...state,
        fetchingItem: false,
        userPermissionsAndRoles: {
          permissions: updatePermission(state.userPermissionsAndRoles.permissions, action.payload),
          roles: state.userPermissionsAndRoles.roles
        },
        currentUsersPermissions: { ...state.currentUsersPermissions, permissions: updateCurrentUsersPermissions(state.currentUsersPermissions, action.payload)}
      }
    case SET_USER_PERMISSIONS_FAIL:
      return { ...state, fetchingItem: false };

    default:
      return state;
  }
};

const updatePermission = (permissionsState, { roleId, permissionId, status }) => {
  Object.keys(permissionsState).forEach((serviceSlug) => {
    permissionsState[serviceSlug].items.forEach((item) => {
      if (item.id === permissionId) {
        status ? item.permissions.push(roleId) : item.permissions = item.permissions.filter((permissionId) => permissionId !== roleId);
      }
    });
  });


  return permissionsState;
};

const updateCurrentUsersPermissions = (permissionsState, { roleId, permissionId, status }) => {
  let array = permissionsState.permissions;
  if (permissionsState.role === roleId) {
    if (status) array.push(permissionId);
    else array = array.filter(item => item !== permissionId);
  }
  return array;
}
